<div class="wrapper">
    <app-webfacing-header *ngIf="!hideHeader"></app-webfacing-header>
    <main>
        <app-trial-banner class="trial-banner-block"></app-trial-banner>
        <router-outlet></router-outlet>
    </main>
</div>